module.exports = __webpack_public_path__ + "express.6818b1.svg";